
import apiClient from './ApiInterceptor';

export const fetchPlans= async (branch, include_hidden = false, expiration_date = null, available_from = null) => {
    try {
        const params = {};
        if (branch) {
            params.branch = branch;
        }
        if (expiration_date) {
            params.expiration_date = expiration_date;
        }
        if (available_from) {
            params.available_from = available_from;
        }
        params.include_hidden = include_hidden;

        const response = await apiClient.get('/plans', { params });
        return response.data;
    } catch (error) {
        console.error('PlanApi - fetchPlan, Error fetching data:', error);
    }
};

export const saveUserPlan= async (formData) => {
    try {
        const response = await apiClient.post('/plans/load', formData);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('PlanApi - saveUserPlan, Error fetching data:', error);
        return { success: false, error };
    }
};

export const activatePlan = async (planId) => {
    const response = await apiClient.post(`/plans/${planId}/activate`);
    return response;
}

export const freezePlan = async (userPlanId, freeze_from, freeze_to, reason, force) => {
    const params = { 
        user_plan_id: userPlanId,
        freeze_from: freeze_from,
        freeze_to: freeze_to || null,
        reason: reason || null,
        force: force || false
    };
    const response = await apiClient.post('/plans/freeze', params);
    return response;
}

export const activePlan = async (user_id) => {
    const response = await apiClient.get(`/plans/${user_id}/active`);
    return response;
}
